// extracted by mini-css-extract-plugin
export var dropdownContainer = "_nc-0";
export var leftAlign = "_nc-4";
export var listItem = "_nc-2";
export var listItemWrapper = "_nc-1";
export var operationText = "_nc-3";